export const apiUrl = import.meta.env.VITE_DJANGO_URL;

export const authHeaders = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return {
      "Content-Type": "application/json",
    };
  }
  return {
    "Content-Type": "application/json",
    Authorization: "Token " + token,
  };
};
